import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import {
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget } from '../../../../ui/widget';
import { AccLoadingPart } from '../acc-loading.part';
import { AcceleratorAreaService } from '../accelerator-area.service';
import { AcceleratorDroplistWidget } from '../accelerator-droplist.widget';
import { AccCohortPageService } from './acc-cohort.page.service';
import { AccCohortTab1Part } from './tabs/tab-1/acc-cohort-tab-1.part';
import { AccCohortTab2Part } from './tabs/tab-2/acc-cohort-tab-2.part';
import { AccCohortViewsPart } from './views/acc-cohort-views.part';


@Component({
	selector: 'acc-cohort-page',
	standalone: true,
	imports: [
		AcceleratorDroplistWidget,
		AccLoadingPart,
		AccCohortTab1Part,
		AccCohortTab2Part,
		AccCohortViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		ToolbarWidget,
		PageTabsWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-cohort.page.html',
})
export class AccCohortPage implements OnInit {

	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	public areaService = inject(AcceleratorAreaService);
	public pageService = inject(AccCohortPageService);

	async ngOnInit() {
		const a = 1;
		// await this.accService.loadDeliveryData();
	}

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}
}